import { FC, ReactNode } from 'react';

export interface PageHeaderProps {
  title: string | ReactNode;
  subtitle?: string | ReactNode;
  actions?: ReactNode;
  badge?: ReactNode;
  className?: string;
}

export const PageHeader: FC<PageHeaderProps> = ({
  title,
  subtitle,
  actions,
  badge,
  className = '',
}) => {
  return (
    <div
      className={`flex flex-col gap-4 pb-1 sm:flex-row sm:items-center sm:justify-between ${className} `}
    >
      <div className="min-w-0 space-y-1">
        <div className="flex flex-wrap items-center gap-2.5">
          {typeof title === 'string' ? (
            <h2 className="text-base font-bold tracking-tight text-content-main sm:text-lg">
              {title}
            </h2>
          ) : (
            title
          )}
          {badge && <div className="flex-shrink-0">{badge}</div>}
        </div>
        {subtitle && (
          <p className="max-w-2xl text-xs leading-relaxed text-content-muted">
            {subtitle}
          </p>
        )}
      </div>

      {actions && (
        <div className="flex flex-shrink-0 flex-wrap items-center gap-2.5">
          {actions}
        </div>
      )}
    </div>
  );
};
